import { Check, X } from "lucide-react";

const forList = [
  "You hold positions for one to six months",
  "You want evidence, not tips",
  "You'd rather be early and patient than late and loud",
];

const notForList = [
  "Day traders. Nothing here moves intraday",
  "Indexers. You're already doing fine, keep going",
  "Anyone who wants certainty. Markets don't sell it",
];

export default function ForNotFor() {
  return (
    <section id="fit" className="fp-section">
      <p className="fp-eyebrow mb-6">Fit</p>
      <h2 className="text-3xl sm:text-4xl font-bold tracking-tight max-w-2xl">
        Built for a specific investor. Maybe not you.
      </h2>
      <div className="mt-12 grid md:grid-cols-2 gap-6">
        <div data-testid="fit-for-card" className="fp-card p-7 border-l-2 border-l-[#2BD97C]">
          <div className="font-mono text-xs uppercase tracking-widest text-[#2BD97C] mb-6">Fundprints is for you if</div>
          <ul className="space-y-4">
            {forList.map((t) => (
              <li key={t} className="flex gap-3 text-sm text-[#E8EBF0]">
                <Check size={16} className="text-[#2BD97C] shrink-0 mt-0.5" />
                {t}
              </li>
            ))}
          </ul>
        </div>
        <div data-testid="fit-notfor-card" className="fp-card p-7 border-l-2 border-l-[#C75E5E]">
          <div className="font-mono text-xs uppercase tracking-widest text-[#C75E5E] mb-6">It is not for</div>
          <ul className="space-y-4">
            {notForList.map((t) => (
              <li key={t} className="flex gap-3 text-sm text-[#8B93A3]">
                <X size={16} className="text-[#C75E5E] shrink-0 mt-0.5" />
                {t}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
